import { useI18n } from '../hooks/useI18n'

/**
 * The one prompt a guest sees, wherever they land.
 *
 * Same rule the mini program had to adopt for WeChat review: browsing is open,
 * and this banner is the invitation rather than a wall. Deliberately short —
 * it sits above real content, it is not the content.
 */
export default function GuestBanner({
  variant = 'events', onRegister
}: { variant?: 'events' | 'six' | 'profile' | 'incomplete'; onRegister?: () => void }) {
  const { t } = useI18n()
  const key = variant === 'incomplete' ? 'incomplete' : variant
  return (
    <div className="mb-3 flex items-center gap-3 rounded-md border border-gold-dim bg-card px-4 py-3">
      <div className="min-w-0 flex-1">
        <p className="text-md font-bold leading-snug text-ivory">{t(`guest.${key}Title`)}</p>
        <p className="mt-0.5 text-sm leading-normal text-muted">{t(`guest.${key}Sub`)}</p>
      </div>
      <button
        type="button"
        // NOT `onClick={onRegister}` — that hands the click EVENT to
        // startRegistration, which passes it to showToast as a title, and
        // React blows up with "Objects are not valid as a React child",
        // blanking the page.
        onClick={() => onRegister && onRegister()}
        className="shrink-0 whitespace-nowrap rounded-pill bg-gold px-5 py-1.5 text-sm font-bold text-[#1a1208]"
      >
        {variant === 'incomplete' ? t('guest.ctaFinish') : t('guest.cta')}
      </button>
    </div>
  )
}
